<template>
  <BaseCard
    class="card-base cursor-pointer space-y-2 lg:p-6"
    @click="toggle"
  >
    <div class="flex items-center justify-between">
      <div class="text-lg text-dynamic">
        {{ props.question.title }}
      </div>
      <button>
        <span class="sr-only">Open/Sluit vraag</span>
        <IconsChevronDown
          class="size-5 text-violet transition-transform"
          :class="{'rotate-180': state.isOpen}"
        />
      </button>
    </div>
    <SofieText
      v-show="state.isOpen"
      :value="props.question.text"
    />
  </BaseCard>
</template>

<script setup lang="ts">
import emitter from 'tiny-emitter/instance.js';
import type {Vraag} from '~/graphql/graphql';

const props = defineProps<{
  question: Vraag;
}>();

const state = ref({
  isOpen: false,
});

const toggle = () => {
  if (!state.value.isOpen) {
    emitter.emit('global:close-faq');
  }
  state.value.isOpen = !state.value.isOpen;
};

emitter.on('global:close-faq', () => {
  state.value.isOpen = false;
});
</script>
